var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuscleActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.3334 16.3201C26.0373 16.1996 24.7344 16.4612 23.5853 17.0725C22.4361 17.6838 21.4911 18.6181 20.8667 19.7601",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6534 17.4269C20.9762 16.866 20.1878 16.4549 19.3403 16.2206C18.4927 15.9864 17.6052 15.9343 16.736 16.0678C15.8669 16.2013 15.0359 16.5174 14.2977 16.9953C13.5596 17.4731 12.931 18.1019 12.4534 18.8402",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.7333 22.4934C14.5624 22.9406 15.4985 23.151 16.4392 23.1016C17.3799 23.0522 18.2889 22.7449 19.0666 22.2134",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5734 18.6664C13.8491 17.3915 14.5967 15.682 14.6667 13.8798C14.7534 12.1952 15.0719 10.5306 15.6134 8.93311",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.7733 25.0669C22.7733 25.0669 14.6666 32.2136 5.33328 23.0802C5.00062 22.7102 4.77419 22.2571 4.67796 21.7689C4.58173 21.2807 4.61927 20.7755 4.78661 20.3069C6.11995 16.9336 7.45328 10.7869 12.9733 5.37357L16.7466 2.81357C16.9985 2.6285 17.3074 2.53779 17.6193 2.55729C17.9312 2.57678 18.2264 2.70524 18.4533 2.92024L21.1199 5.41357C21.2469 5.53775 21.3478 5.68604 21.4167 5.84975C21.4856 6.01346 21.5211 6.18929 21.5211 6.3669C21.5211 6.54452 21.4856 6.72034 21.4167 6.88405C21.3478 7.04777 21.2469 7.19606 21.1199 7.32024C20.0133 8.45357 17.9866 9.72024 15.9999 6.68024",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.3334 26.0532C21.3334 26.0532 22.5334 26.3332 23.32 29.4532",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuscleActive);
export default __webpack_public_path__ + "static/media/muscleActive.d763b2d9aa4b94be6bb7a54c74950b3f.svg";
export { ForwardRef as ReactComponent };